import * as React from 'react';
import { 
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';

export default function TitleModal(props) {
  const {open, value, caption, handleSave, handleClose} = props;
  const [title, setTitle] = React.useState(value);

  const handleTitle = (e) => {
    setTitle(e.target.value)
  }

  React.useEffect(() => {
    setTitle(value)
  }, [value]);

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>{caption? caption: 'Edit Title'}</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <CTextField
            required
            margin="dense"
            id="title"
            name="title"
            label="Title"
            type="text"
            size="small"
            fullWidth
            variant="outlined"
            value={title}
            onChange={handleTitle}
          />
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={() => handleSave(title)}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}